import { SubscriptionDetails } from '@anm/api/modules/subscription';
import { UserSubscriptionDetails } from '@anm/api/modules/user';

const getFreeSubscription = (
  subscriptionList: (UserSubscriptionDetails | SubscriptionDetails)[]
) => subscriptionList?.find(s => s.name === 'WaveFree');

export default getFreeSubscription;
